/**
 * 7Days Food LP Custom JavaScript
 */
(() => {
	document.addEventListener("DOMContentLoaded", () => {
		// LP wrapperが存在する場合のみ実行
		if (document.querySelector('.lp-wrapper')) {
			document.body.classList.add('lp-page');
			init();
		}
	});
})();

const init = () => {
	banner();
	lineupObj();
	feedObj();
	anchorLink();
}

const anchorLink = () => {
	const anchors = document.querySelectorAll('.btn-anchor');
	anchors.forEach(anchor => {
		anchor.addEventListener('click', (e) => {
			e.preventDefault();
			const href = anchor.getAttribute('href');
			const target = document.querySelector(href);
			if (target) {
				const offset = 0;
				const position = target.getBoundingClientRect().top + window.pageYOffset - offset;
				window.scrollTo({
					top: position,
					behavior: 'smooth'
				});
			}
		});
	});
}

const banner = () => {
	const bannerArea = document.querySelector('#lp-banner-area');
	const heroSection = document.querySelector('#lp-hero');

	if (!bannerArea || !heroSection) return;

	const handleScroll = () => {
		const bannerHeight = bannerArea.clientHeight;
		const position = heroSection.getBoundingClientRect().bottom + bannerHeight;
		const windowHeight = window.innerHeight;

		if (position < windowHeight) {
			document.body.classList.add('lp-js-on');
		} else {
			document.body.classList.remove('lp-js-on');
		}
	};

	window.addEventListener('scroll', handleScroll);
	handleScroll();
}

const lineupObj = () => {
	const lineupElement = document.querySelector('.lineup-list.splide');
	if (!lineupElement) return;

	var splide = new Splide('.lineup-list.splide', {
		type: "loop",
		pagination: false,
		rewind: true,
		gap: '20px',
		padding: '40px',
		breakpoints: {
			389: {
				gap: '5.1282vw',
				padding: '10.2564vw',
			},
		},
	});
	splide.mount();
}

const feedObj = () => {
	const feedElement = document.querySelector('.feed-list.splide');
	if (!feedElement) return;

	var splide = new Splide('.feed-list.splide', {
		pagination: false,
		rewind: true,
		gap: '52px',
		padding: '52px',
		breakpoints: {
			389: {
				gap: '13.3333vw',
				padding: '13.3333vw',
			},
		},
	});
	splide.mount();
}
